const FALLBACK_NAME = 'Your photographer';

export function photographerDisplayName(name: string | null | undefined): string {
  const clean = name?.trim();
  return clean || FALLBACK_NAME;
}

export function photographerShortName(name: string | null | undefined): string {
  const clean = photographerDisplayName(name);
  if (clean.toLowerCase() === FALLBACK_NAME.toLowerCase()) return 'your photographer';
  return clean.split(/\s+/)[0] || clean;
}

export function photographerPickLabel(name: string | null | undefined): string {
  const short = photographerShortName(name);
  return short === 'your photographer' ? "Photographer's pick" : `${short}'s pick`;
}
